import { render } from "./AdminWithdrawal.vue?vue&type=template&id=f56a368a&scoped=true"
import script from "./AdminWithdrawal.vue?vue&type=script&lang=js"
export * from "./AdminWithdrawal.vue?vue&type=script&lang=js"

import "./AdminWithdrawal.vue?vue&type=style&index=0&id=f56a368a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56a368a"]])

export default __exports__